import { IUserReceiveInfo } from 'redhotpie-shared-lib/functions/types/popoverTypes';
import { parseDateString } from '../functions/utils';

export interface FeatureRoomsObject {
  RoomId: number;
  RoomJID: string;
  StartTime: string;
  EndTime: string;
  MobileBannerURL: string;
  DesktopBannerURL: string;
  Occupants: number;
  OwnerUserId: number;
  OwnerXmppId: string;
  Name: string;
  RoomDisplayName: string;
  IsFeatureRoom: boolean;
  IsOwner: boolean;
  HasReminder: boolean;
}

export class Room {
  id: number;
  roomId: number;
  roomJid: string;
  roomName: string;
  roomDisplayName: string;
  isFeatureRoom: boolean;
  occupants: number;
  members: IUserReceiveInfo[];
  isOwner: boolean;
  owner?: IUserReceiveInfo;
  ownerUserId?: number;

  constructor() {
    this.id = 0;
    this.roomId = 0;
    this.roomJid = '';
    this.roomName = '';
    this.roomDisplayName = '';
    this.isFeatureRoom = false;
    this.occupants = 0;
    this.members = [];
    this.isOwner = false;
    this.owner = undefined;
  }
}

export class LivestreamRoom extends Room {
  name: string;
  streamId: string;
  avatarUrl: string;
  listViewer: IUserReceiveInfo[];
  constructor() {
    super();
    this.name = '';
    this.streamId = '';
    this.avatarUrl = '';
    this.listViewer = [];
  }
}

export class FeatureRooms extends Room {
  startTime: any;
  endTime: any;
  mobileBannerURL: string;
  desktopBannerURL: string;
  ownerXmppId: string | null;
  isOwner: boolean;
  hasReminder: boolean;

  constructor(featureRoomsObject: FeatureRoomsObject) {
    super();
    this.roomId = featureRoomsObject.RoomId || 0; // number
    this.id = featureRoomsObject.RoomId || 0; // number
    this.roomJid = featureRoomsObject.RoomJID || ''; // rhp#testing_public_user_1108455037579_ja0xwxzqih@muc.chatxmpp.redhotpie.com.au
    this.startTime = parseDateString(featureRoomsObject.StartTime) || null;
    this.endTime = parseDateString(featureRoomsObject.EndTime) || null;
    this.mobileBannerURL = featureRoomsObject.MobileBannerURL || '';
    this.desktopBannerURL = featureRoomsObject.DesktopBannerURL || '';
    this.occupants = featureRoomsObject.Occupants || 0;
    this.ownerUserId = featureRoomsObject.OwnerUserId;
    this.ownerXmppId = featureRoomsObject.OwnerXmppId || null;
    this.roomName = featureRoomsObject.Name || '';
    this.roomDisplayName = featureRoomsObject.Name || '';
    this.isFeatureRoom = true;
    this.isOwner = false;
    this.hasReminder = featureRoomsObject.HasReminder || false;
  }
}

export class ChatRoom extends Room {
  coverUrl: string;
  liveMembers: string;

  constructor() {
    super();
    this.coverUrl = '';
    this.liveMembers = '0';
  }

  static mappingObject(_room: any): ChatRoom {
    if (_room) {
      const room = new ChatRoom();
      room.id = _room.id || 0;
      room.roomId = _room.roomId || _room.id || 0;
      room.roomJid = _room.roomJid || '';
      room.roomName = _room.roomName || '';
      room.coverUrl = _room.coverUrl || '';
      room.roomDisplayName = _room.roomDisplayName || '';
      room.occupants = _room.occupants || null;
      room.liveMembers = _room.occupants || '0';
      return room;
    }
    return new ChatRoom();
  }

  static mappingObjects(_rooms: any[]): ChatRoom[] {
    const rooms: ChatRoom[] = [];
    _rooms.forEach(_room => {
      const room = ChatRoom.mappingObject(_room);
      rooms.push(room);
    });
    return rooms;
  }
}

export default ChatRoom;
